module.exports = __webpack_public_path__ + "img/2D-3BHK.0b531486.png";